module.exports = __webpack_public_path__ + "img/campaign-discount.a592dccb.svg";